import React from 'react';
import { BrainIcon, ZapIcon, SmileIcon, HeartPulseIcon, SparklesIcon, ClockIcon, TrendingUpIcon, ShieldIcon } from 'lucide-react';
export function Benefits() {
  return <section className="mb-12" data-id="element-18">
      <h2 className="text-2xl md:text-3xl font-bold text-amber-800 mb-2 text-center" data-id="element-19">
        Fördelarna jag upplevde med Brainy
      </h2>
      <p className="text-center mb-6 text-gray-600" data-id="element-20">
        <span className="italic" data-id="element-21">
          Medan mina jämnåriga fortsatte att klaga över "seniormoment"...
        </span>
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-22">
        <div className="bg-white p-5 rounded-lg shadow-md relative overflow-hidden" data-id="element-23">
          <div className="absolute top-0 right-0 bg-green-500 text-white text-xs px-2 py-1 uppercase tracking-wider" data-id="element-24">
            Vecka 1-2
          </div>
          <div className="flex items-center mb-3" data-id="element-25">
            <div className="bg-amber-100 p-3 rounded-full mr-3" data-id="element-26">
              <BrainIcon className="h-6 w-6 text-amber-800" data-id="element-27" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800" data-id="element-28">
              Förbättrat minne & återkallning
            </h3>
          </div>
          <p data-id="element-29">
            Jag kunde äntligen komma ihåg namn, datum och viktiga detaljer igen.
            <span className="font-semibold" data-id="element-30">
              {' '}
              Känslan när jag kunde ringa min dotters nummer utan att leta i
              kontaktlistan var obeskrivlig.
            </span>{' '}
            Plötsligt var jag "den smarta igen" i familjen.
          </p>
          <div className="mt-3 text-xs text-gray-500" data-id="element-31">
            <TrendingUpIcon className="h-3 w-3 inline mr-1" data-id="element-32" />
            <span data-id="element-33">83% av användarna rapporterar denna förbättring</span>
          </div>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-md relative overflow-hidden" data-id="element-34">
          <div className="absolute top-0 right-0 bg-green-500 text-white text-xs px-2 py-1 uppercase tracking-wider" data-id="element-35">
            Vecka 2-3
          </div>
          <div className="flex items-center mb-3" data-id="element-36">
            <div className="bg-amber-100 p-3 rounded-full mr-3" data-id="element-37">
              <ZapIcon className="h-6 w-6 text-amber-800" data-id="element-38" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800" data-id="element-39">
              Bättre koncentration
            </h3>
          </div>
          <p data-id="element-40">
            Jag kunde fokusera på en uppgift i taget utan att bli distraherad.
            <span className="font-medium" data-id="element-41">
              {' '}
              Medan mina vänner fortfarande kämpade med att hålla tråden i
              samtal, kunde jag nu följa komplexa diskussioner utan problem.
            </span>
          </p>
          <div className="mt-3 text-xs text-gray-500" data-id="element-42">
            <TrendingUpIcon className="h-3 w-3 inline mr-1" data-id="element-43" />
            <span data-id="element-44">91% av användarna rapporterar denna förbättring</span>
          </div>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-md relative overflow-hidden" data-id="element-45">
          <div className="absolute top-0 right-0 bg-green-500 text-white text-xs px-2 py-1 uppercase tracking-wider" data-id="element-46">
            Vecka 3-4
          </div>
          <div className="flex items-center mb-3" data-id="element-47">
            <div className="bg-amber-100 p-3 rounded-full mr-3" data-id="element-48">
              <SmileIcon className="h-6 w-6 text-amber-800" data-id="element-49" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800" data-id="element-50">
              Förbättrat humör & mental klarhet
            </h3>
          </div>
          <p data-id="element-51">
            Den frustration och ångest jag kände över min försämrade
            hjärnfunktion försvann.{' '}
            <span className="italic" data-id="element-52">
              Medan mina vänner fortsatte att skämta om "åldersglömska", kände
              jag mig mentalt skarpare än på åratal.
            </span>
          </p>
          <div className="mt-3 text-xs text-gray-500" data-id="element-53">
            <TrendingUpIcon className="h-3 w-3 inline mr-1" data-id="element-54" />
            <span data-id="element-55">78% av användarna rapporterar denna förbättring</span>
          </div>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-md relative overflow-hidden" data-id="element-56">
          <div className="absolute top-0 right-0 bg-amber-500 text-white text-xs px-2 py-1 uppercase tracking-wider" data-id="element-57">
            Vecka 4-8
          </div>
          <div className="flex items-center mb-3" data-id="element-58">
            <div className="bg-amber-100 p-3 rounded-full mr-3" data-id="element-59">
              <HeartPulseIcon className="h-6 w-6 text-amber-800" data-id="element-60" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800" data-id="element-61">
              Stöd för hjärnans signalsubstanser
            </h3>
          </div>
          <p data-id="element-62">
            <span className="font-medium" data-id="element-63">
              Medan mina jämnåriga började med mediciner för nedstämdhet,
            </span>{' '}
            hjälpte B-vitaminerna i Brainy till att stödja produktionen av
            signalsubstanser som är viktiga för humör och kognition.
          </p>
          <div className="mt-3 text-xs text-gray-500" data-id="element-64">
            <ShieldIcon className="h-3 w-3 inline mr-1" data-id="element-65" />
            <span data-id="element-66">Bekräftat i kliniska studier från 2022</span>
          </div>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-md md:col-span-2" data-id="element-67">
          <div className="flex items-center mb-3" data-id="element-68">
            <div className="bg-amber-100 p-3 rounded-full mr-3" data-id="element-69">
              <SparklesIcon className="h-6 w-6 text-amber-800" data-id="element-70" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800" data-id="element-71">
              Anti-åldrande fördelar för hjärnan
            </h3>
          </div>
          <p data-id="element-72">
            De antioxidanter som finns i Brainy hjälper till att skydda hjärnan
            mot oxidativ stress och åldrande.{' '}
            <span className="text-red-700 font-medium" data-id="element-73">
              Tänk på det: din hjärna kan åldras snabbare än din kropp utan att
              du märker det.
            </span>{' '}
            Med Brainy känner jag mig mentalt yngre och skarpare än jag gjort på
            flera år!
          </p>
          <div className="mt-3 flex items-center justify-between" data-id="element-74">
            <div className="text-xs text-gray-500" data-id="element-75">
              <ClockIcon className="h-3 w-3 inline mr-1" data-id="element-76" />
              <span data-id="element-77">Långsiktiga fördelar ökar med fortsatt användning</span>
            </div>
            <div className="text-xs text-amber-600 font-medium" data-id="element-78">
              "Jag märker fortfarande nya förbättringar efter 6 månader"
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8 bg-red-50 border border-red-200 p-4 rounded-lg" data-id="element-79">
        <h3 className="text-lg font-semibold text-red-700 mb-2" data-id="element-80">
          Varför vänta tills det är för sent?
        </h3>
        <p className="mb-2" data-id="element-81">
          Enligt en ny studie från Uppsala Universitet börjar hjärnceller dö
          redan vid 30 års ålder - långt innan du märker några symptom.{' '}
          <span className="font-medium" data-id="element-82">
            Varje dag utan näringsämnen som skyddar din hjärna är en förlorad
            dag.
          </span>
        </p>
        <p className="text-sm" data-id="element-83">
          Forskare kallar detta "det tysta förfallet" - en process som pågår i
          åratal innan du ens märker att något är fel.
        </p>
      </div>
    </section>;
}